import {IosServerName, isTmcOrder, OrderRecord, TmcLeg} from "../OrderRecord";

export type IressOrderRecords = ReadonlyArray<IressOrderRecord>;

export interface IressOrderRecord extends OrderRecord {
    readonly iosServer: IosServerName;
    readonly doneTodayQuantity: number;
    readonly doneTodayValue: number;
    readonly childOrders: ReadonlyArray<IressOrderRecord>;
    readonly isInternal: boolean; // Indicates that the order was placed through this system
}

export interface IressTmcOrderRecord extends IressOrderRecord {
    readonly childOrders: ReadonlyArray<IressTmcOrderRecord>;
    readonly legs: ReadonlyArray<TmcLeg>;
}

export function isIressOrder(order: OrderRecord): order is IressOrderRecord {
    return "iosServer" in order;
}

export function isIressTmcOrder(order: OrderRecord): order is IressTmcOrderRecord {
    return isTmcOrder(order) && isIressOrder(order);
}
